import { GenerateClaimStatus } from './ClaimStatusText';
import './ClaimTracker.scss';

const ClaimTracker = function ({ claim }) {
    let status = GenerateClaimStatus({ claim });

    let iconColors = {};
    ["start", "docs", "check", "finish"].forEach((v, idx) => {
        if (idx < status.icon)
            iconColors[v] = status.colorText;
    });

    return (
        <div className={`claim-tracker`}>
            <div className="line">
                <div className="secondary" style={{ width: ((status.icon - 1) / 3 * 100) + "%", backgroundColor: "#555A60" }}></div>
                <img className="icon start" src={`/img/tracker/icon-1${iconColors.start || ""}.svg`} alt="Start" />
                <img className="icon docs" src={`/img/tracker/icon-2${iconColors.docs || ""}.svg`} alt="Documents" />
                <img className="icon check" src={`/img/tracker/icon-3${iconColors.check || ""}.svg`} alt="Checking" />
                <img className="icon finish" src={`/img/tracker/icon-4${iconColors.finish || ""}.svg`} alt="finished" />
            </div>
        </div>
    );
};

export { ClaimTracker };